import React from 'react'
import OffLine from '../off-line'

const OffLineDa = () => {
    return <OffLine languageCode="da" />
}

export default OffLineDa
